<template>
  <div :class="{ 'has-error': validacao.$error }" class="form-group">
    <label v-if="exibeLabel">
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <div class="input-group" :class="inputGroupClass">
      <input
        :id="id"
        v-model="valorData"
        v-mask="'99/99/9999'"
        :data-test-id="`input-${id}`"
        :name="id"
        :placeholder="label"
        :readonly="somenteLeitura"
        type="text"
        class="form-control"
        @change="atualizarData($event.target.value)"
      />
      <div v-if="!somenteLeitura" class="input-group-addon">
        <span
          type="button"
          class="dropdown-toggle"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span class="fa fa-calendar" />
        </span>
        <span class="dropdown-menu">
          <li>
            <DatePicker
              v-model="valorData"
              :today-btn="false"
              :clear-btn="false"
              :format="'dd/MM/yyyy'"
              :close-on-selected="true"
              :date-parser="dataParser"
              class="date-picker"
              @input="atualizarData($event)"
            />
          </li>
        </span>
      </div>
    </div>
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask'
import moment from 'moment'

import { campoMixin } from '@/mixins/CampoMixin'

export default {
  name: 'SelecionarData',
  directives: { mask: AwesomeMask },
  mixins: [campoMixin],
  props: {
    label: {
      type: String,
      default: 'Data',
    },
    id: {
      type: String,
      default: 'data',
    },
    valor: {
      type: [String, Date],
      default: '',
    },
    inputGroupClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      valorData: null,
    }
  },
  watch: {
    valor() {
      if (this.valor) {
        if (moment(this.valor).isValid()) {
          this.valorData = moment(this.valor).format('DD/MM/YYYY')
        } else if (moment(this.valor, 'DD/MM/YYYY').isValid()) {
          this.valorData = moment(this.valor, 'DD/MM/YYYY').format('DD/MM/YYYY')
        }
      }
    },
  },
  created() {
    if (this.valor) {
      if (moment(this.valor).isValid()) {
        this.valorData = moment(this.valor).format('DD/MM/YYYY')
      } else if (moment(this.valor, 'DD/MM/YYYY').isValid()) {
        this.valorData = moment(this.valor, 'DD/MM/YYYY').format('DD/MM/YYYY')
      }

      this.atualizarData()
    }
  },
  methods: {
    atualizarData(event) {
      if (event) {
        this.valorData = event
      }

      if (this.validacao.$touch) {
        this.validacao.$touch()
      }

      if (this.valorData && this.valorData.length === 10) {
        const momentValor = moment(this.valorData, 'DD/MM/YYYY')
        const data = momentValor.format()
        this.$emit('atualizar', data)
      } else if (this.valorData === '') {
        this.$emit('atualizar', '')
      }
    },
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
  },
}
</script>
